import { SignUpParams } from 'web/services/api/queries';

// Mirrors the server's Identity password policy (nervex-dotnet MainServer
// Startup.cs): uppercase, lowercase, digit, non-alphanumeric, length >= 8.
export const PASSWORD_POLICY_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,}$/;

// Builds the sign-up request body from the raw form values. The password is
// transmitted exactly as validated: trimming it would let a password whose
// only symbol is an edge space pass step 1 yet fail on the server, and would
// store a different password than the user typed (login never trims).
export const buildSignUpParams = (
    data: SignUpParams,
    extras: { invitationCode?: string; token?: string },
): SignUpParams => ({
    firstName: data.firstName?.trim(),
    lastName: data.lastName?.trim(),
    organizationName: data.organizationName?.trim(),
    email: data.email?.trim(),
    password: data.password,
    promoCode: data.promoCode?.trim(),
    referralCode: data.referralCode?.trim(),
    recaptchaToken: data.recaptchaToken?.trim(),
    invitationCode: extras.invitationCode,
    token: extras.token,
});
